import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Tooltip } from 'primereact/tooltip';
import { useRef } from 'react';

const DEFAULT_TOOLTIP_STYLE = {
  whiteSpace: 'normal'
};
function isTruncated(target) {
  return Math.ceil(target.scrollWidth) > Math.ceil(target.clientWidth);
}
function getDefaultTooltipAlignment(tooltipPosition) {
  if (tooltipPosition === 'bottom') {
    return {
      tooltipMy: 'left top',
      tooltipAt: 'left bottom'
    };
  }
  if (tooltipPosition === 'left') {
    return {
      tooltipMy: 'right center',
      tooltipAt: 'left center'
    };
  }
  if (tooltipPosition === 'right') {
    return {
      tooltipMy: 'left center',
      tooltipAt: 'right center'
    };
  }
  return {
    tooltipMy: 'left bottom',
    tooltipAt: 'left top'
  };
}
function OverflowTooltipLabel(_ref) {
  let {
    label,
    className,
    tooltipPosition = 'top',
    tooltipStyle = DEFAULT_TOOLTIP_STYLE,
    tooltipMy,
    tooltipAt
  } = _ref;
  const labelRef = useRef(null);
  const defaultAlignment = getDefaultTooltipAlignment(tooltipPosition);
  return jsxs(Fragment, {
    children: [jsx(Tooltip, {
      target: labelRef,
      className: "ics-overflow-tooltip",
      content: label,
      position: tooltipPosition,
      style: tooltipStyle,
      my: tooltipMy !== null && tooltipMy !== void 0 ? tooltipMy : defaultAlignment.tooltipMy,
      at: tooltipAt !== null && tooltipAt !== void 0 ? tooltipAt : defaultAlignment.tooltipAt,
      onBeforeShow: event => isTruncated(event.target)
    }), jsx("span", {
      ref: labelRef,
      className: className,
      children: label
    })]
  });
}
function renderOverflowTooltipLabel(label, className) {
  if (!label) {
    return null;
  }
  return jsx(OverflowTooltipLabel, {
    label: label,
    className: className
  });
}

export { OverflowTooltipLabel, renderOverflowTooltipLabel };
